import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Cart/CartCheck/cartCheck.container"
    ).then((module) => ({
        default: module.CartCheckContainer
    }))
);
